// @flow
import React from 'react';
import Button from '@localytics/loc-components/lib/Button';
import Dialog, { DialogControls } from './dialogs/Dialog';
import './stylesheets/TempButton.scss';

type ConfirmationDialogProps = {
  showConfirmationDialog: boolean,
  nodeTitle: string,
  onCancel: Function,
  onDontSave: Function,
  onSave: Function
};

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    showConfirmationDialog,
    nodeTitle,
    onCancel,
    onDontSave,
    onSave
  } = props;
  return (
    <Dialog show={showConfirmationDialog}>
      <div className="ConfirmationDialogText">
        <b>
          Do you want to save the changes you’ve made to {nodeTitle} before
          closing?
        </b>
        <br />
        If you don’t save your changes will be lost.
      </div>
      <DialogControls>
        <Button className="TempButton" onClick={onDontSave}>
          Don’t Save
        </Button>
        <Button className="TempButton" onClick={onCancel}>
          Cancel
        </Button>
        <Button className="TempPrimaryButton" onClick={onSave}>
          Save
        </Button>
      </DialogControls>
    </Dialog>
  );
};

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/ConfirmationDialog.jsx